<template>
  <div>
    Tournaments list
  </div>
</template>

<script>
  export default {
    name: 'AdminTournaments',
    props: ['user'],
    data () {
      return {}
    },
    created () {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    methods: {}
  }
</script>